import React from 'react';
import { useParams } from 'react-router-dom';
import DefaultLayout from '../../../layouts/default';
import { TrainingRecordFormProvider } from '../context/TrainingRecordFormContext';
import TrainingRecordForm from '../components/TrainingRecordForm';
export default function EditTrainingRecord() { const { id } = useParams(); return <DefaultLayout><TrainingRecordFormProvider id={id}><TrainingRecordForm /></TrainingRecordFormProvider></DefaultLayout>; }
